import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_care/therapy-payroll")({
  beforeLoad: ({ context }) => guardRoute(context.me, "therapy-payroll"),
  component: Outlet,
});
